import React from 'react'
import withStyles from 'react-jss'
import Titre1 from 'src/components/font/Titre1'
import Titre2 from 'src/components/font/Titre2'
import routes from 'src/routing/routes'
import { Col, Row } from 'react-bootstrap'
import { interpretHtml } from 'src/utils'
import Spinner from 'src/components/Spinner'
import { responsiveAd, smBannerAd } from '../../../../../config/dataConf'
import PubContainer from '../../../../../components/PubContainer'
import responsiveComponent from '../../../../../hoc/responsiveComponent'
import { withRouter } from 'react-router'
import LazyLoad from 'react-lazy-load'
import ImageLoader from '../../../../../components/ImageLoader'

const styles = theme => ({
  producerContainer: {
    '&:hover': {
      backgroundColor: theme.listeProducteur.hoverColor,
      textDecoration: 'none',
      cursor: 'pointer'
    },
    padding: '15px 15px 0px'
  },
  imageContainer: {
    textAlign: 'center'
  },
  imageProducer: {
    maxHeight: 288.55,
    maxWidth: '100%'
  },
  producerSeparator: {
    marginBottom: 0
  },
  hrSeparator: {
    borderColor: theme.Plan.hrColor
  },
  textProducer: {
    display: 'inline-block'
  },
  ads: {
    textAlign: 'center'
  },
  companyName: {
    marginTop: 10
  },
  presentation: {
    marginBottom: 10
  }
})

const ListProducersByRegion = ({
  loading,
  classes,
  data,
  isMobile,
  history
}) => {
  const toProducerPage = id => {
    history.push(routes.ficheProducteur.replace(':id(\\d+)', id))
  }

  return !loading && data && !data.error ? (
    data.regionsWithProducers.map((regionWithProducer, i) => {
      const region = regionWithProducer.region
      const producers = regionWithProducer.producers

      return producers.length > 0 ? (
        <div key={i}>
          <Titre1 component='h2'>{region.name}</Titre1>
          {producers.map((producer, j) => (
            <div key={j} onClick={() => toProducerPage(producer.id)}>
              <div className={classes.producerContainer}>
                <Row>
                  <Col xs={12} sm={3} className={classes.imageContainer}>
                    <LazyLoad
                      width={'100%'}
                      height={288.55}
                      debounce={false}
                      offsetVertical={2000}
                    >
                      <ImageLoader
                        src={producer.photoProducerUrl || '/img/no_photo.jpg'}
                        alt={producer.companyName}
                        className={classes.imageProducer}
                      />
                    </LazyLoad>
                  </Col>
                  <Col xs={12} sm={9}>
                    <Titre2 component='p' className={classes.companyName}>
                      {producer.companyName}
                    </Titre2>
                    <div className={classes.presentation}>
                      {producer.presentation &&
                      producer.presentation.trim().length > 0
                        ? interpretHtml(
                            producer.presentation
                              .replace(/\n/g, '<br/>')
                              .substr(0, 750) + '...'
                          )
                        : 'Pas de présentation.'}
                    </div>
                  </Col>
                </Row>
                {j !== producers.length - 1 && (
                  <hr className={classes.producerSeparator} />
                )}
              </div>
            </div>
          ))}
          <hr className={classes.hrSeparator} />

          <PubContainer
            scriptPubCore={isMobile ? responsiveAd : smBannerAd}
            className={classes.ads}
          />

          <hr className={classes.hrSeparator} />
        </div>
      ) : null
    })
  ) : (
    <Spinner />
  )
}

export default responsiveComponent(
  withRouter(withStyles(styles)(ListProducersByRegion))
)
